import qs from 'qs'
import Request from '../../common/request';
export const sendSmsCode = (data) => Request.post('/usercenter/api/sendMsg', qs.stringify(data), {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
    network403: 'custom403'
});
export const login = (data) => Request.post(`/usercenter/api/login`, qs.stringify(data), {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
    network403: 'custom403'
})

export const signProtocol = data => Request.get('/usercenter/api/renewSignUserProtocol?' + qs.stringify(data));

// 登出
export const loginout = () => Request.get(`/usercenter/api/logout`)